{
  "fr": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Oui, supprimer",
        "text": "Voulez-vous vraiment supprimer \"{filename}\" ? Le fichier et son contenu de programme recherchable seront supprimes.",
        "title": "Supprimer le programme ?"
      },
      "confirmedUseful": "Le programme a ete confirme pour la recherche.",
      "confirmUseful": "Utiliser pour la recherche de programmes",
      "confirmUsefulFailed": "Le programme n'a pas pu etre confirme.",
      "configure": "Ouvrir les reglages du programme",
      "contextPanel": {
        "loadFailed": "Les programmes scolaires n'ont pas pu être chargés pour le moment. Réessaie plus tard.",
        "manage": "Gérer ses propres programmes scolaires",
        "matching": "Ces programmes scolaires correspondent aux données scolaires ci-dessus.",
        "noSubject": "Choisis une matière ci-dessus, nous t'afficherons les programmes scolaires correspondants.",
        "noSubjectMatch": "Nous n'avons pas de programme scolaire pour la matière sélectionnée. Télécharge le tien, l'IA l'utilisera alors.",
        "none": "Nous n'avons pas encore de programme scolaire pour ces données. Télécharge le tien, l'IA l'utilisera alors.",
        "notFound": "Pour les données ci-dessus, nous n'avons trouvé aucun programme scolaire adapté dans {place}. Télécharge le tien, l'IA l'utilisera alors.",
        "ownDocument": "document personnel",
        "title": "Programmes scolaires",
        "unknownRegion": "Nous ne connaissons pas ton Land. Pour éviter que l'IA n'utilise un mauvais programme scolaire, elle n'en utilisera aucun. Indique ton Land dans ton profil.",
        "used": "Ce matériel est basé sur ces programmes scolaires.",
        "usedIn": "Ce matériel est basé sur ces programmes scolaires pour {place}."
      },
      "coverage": {
        "covered": "couvert",
        "grades": "Classe {range}",
        "heading": "Tes matières dans {place}",
        "headingWithoutPlace": "Tes matières",
        "notCovered": "non couvert",
        "openProfile": "Ouvrir le profil",
        "profileIncomplete": "Déposez vos matières, type d'école et niveaux de classe dans le profil, puis nous vous montrerons les programmes correspondants ici.",
        "tooltip": {
          "covered": "Par exemple {example}",
          "coveredMore": "Par exemple {example} et autres",
          "notCovered": "Pour {place}, nous n'avons pas encore de programme officiel. Télécharge le tien, puis l'IA l'utilisera.",
          "otherRegions": "Pour {place}, nous n'avons pas encore de programme officiel, seulement pour d'autres Länder. Télécharge le tien, puis l'IA l'utilisera."
        },
        "unmapped": "Il n'existe pas de programme propre pour {labels}. Téléchargez le vôtre, puis l'IA l'utilisera."
      },
      "delete": "Supprimer le programme",
      "deleted": "Le programme a ete supprime.",
      "deleteFailed": "Le programme n'a pas pu etre supprime.",
      "empty": "Aucun document de programme personnel n'a encore ete importe.",
      "documentKindDescriptions": {
        "cross_curricular_framework": "Un cadre transversal, par exemple pour l'education aux medias ou les competences numeriques.",
        "curriculum_guidance": "Un guide, commentaire ou support d'accompagnement pour travailler avec un programme.",
        "general_curriculum_part": "Une partie generale du programme sans matiere unique, par exemple des principes ou objectifs transversaux.",
        "non_curriculum": "Ce fichier n'a pas ete reconnu comme un document de programme.",
        "presentation_or_training_material": "Un support de presentation ou de formation sur les programmes, mais pas le programme lui-meme.",
        "subject_curriculum": "Un programme specifique a une matiere ou des exigences disciplinaires.",
        "unknown": "Le type de document n'a pas pu etre determine de facon fiable."
      },
      "documentKindLabels": {
        "cross_curricular_framework": "Cadre transversal",
        "curriculum_guidance": "Guide",
        "general_curriculum_part": "Partie generale du programme",
        "non_curriculum": "Pas un programme",
        "presentation_or_training_material": "Presentation / formation",
        "subject_curriculum": "Programme disciplinaire",
        "unknown": "Incertain"
      },
      "fields": {
        "country": "Pays",
        "documentKind": "Type de document",
        "gradeLevel": "Niveau de classe",
        "region": "Region",
        "schoolType": "Type d'ecole",
        "subject": "Matiere",
        "title": "Titre",
        "customGradeLevel": "Niveau de classe propre",
        "customSchoolType": "Type d'école propre",
        "customSubject": "Matière propre"
      },
      "hints": {
        "customCategoryValue": "Introuvable ? Saisissez votre propre valeur."
      },
      "intro": "Nous utilisons les programmes officiels d'Allemagne, d'Autriche et de Suisse. Tu peux également télécharger tes propres documents de programme, par exemple un programme interne à l'école. L'IA les prend en compte en même temps que les programmes officiels.",
      "loading": "Chargement des programmes...",
      "needsReview": "Nous n'avons pas pu rattacher clairement ce document a un programme, une matiere, un niveau de classe ou un type d'ecole. Il ne sera probablement que partiellement utile pour la recherche de programmes. Veuillez completer les metadonnees ou supprimer le fichier.",
      "notSet": "Non defini",
      "placeholders": {
        "selectOrAddOptions": "Rechercher, selectionner ou saisir une valeur",
        "addCustomValues": "Ajouter ses propres valeurs"
      },
      "saved": "Metadonnees du programme enregistrees.",
      "states": {
        "classification_failed": "Classification automatique echouee",
        "classifying": "Analyse du programme en cours",
        "file_processing_failed": "Le fichier n'a pas pu etre lu",
        "import_failed": "Import echoue",
        "indexing": "Ajout a la recherche de programmes",
        "needs_review": "Verification necessaire",
        "official": "Programme officiel",
        "processing_file": "Le fichier est en cours de traitement",
        "searchable": "Recherchable"
      },
      "statusDescriptions": {
        "classification_failed": "La classification automatique n'a pas pu determiner de facon fiable la matiere, le niveau ou le type d'ecole. Vous pouvez modifier les metadonnees manuellement.",
        "classifying": "Le texte du programme est analyse afin de proposer la matiere, le niveau et le type d'ecole.",
        "file_processing_failed": "Le fichier n'a pas pu etre lu. Veuillez importer un autre fichier PDF, DOCX ou texte.",
        "import_failed": "Le programme n'a pas pu etre ajoute a la recherche de programmes. Vous pouvez verifier les metadonnees et enregistrer a nouveau.",
        "indexing": "Le fichier a ete classifie et est prepare pour la recherche de programmes.",
        "needs_review": "Le fichier a ete traite, mais les metadonnees du programme sont peu claires ou incompletes.",
        "official": "Des donnees officielles de programme sont disponibles pour ce domaine.",
        "processing_file": "Le fichier est lu et son texte est extrait.",
        "searchable": "Le programme est indexe et peut etre utilise par la recherche de programmes."
      },
      "title": "Programmes",
      "upload": "Importer un programme",
      "uploaded": "Le programme a ete importe et est en cours de traitement.",
      "uploadFailed": "Le programme n'a pas pu etre importe."
    }
  }
}
